import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const getToken = () => localStorage.getItem("token");

export const Messageslist = async (page, limit) => {
  return axios.get(`${API_BASE_URL}/chat/rooms`, {
    params: { page, limit },
    headers: { token: getToken() },
  });
};

export const MessageslistId = async (roomId, offset = 1, limit = 20) => {
  return axios.get(
    `${API_BASE_URL}/chat/rooms/${roomId}/messages?offset=${offset}&limit=${limit}`,
    {
      headers: { token: getToken() },
    },
  );
};

export const UploadSingleMessageFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios.post(`${API_BASE_URL}/upload/singlefile`, formData, {
    headers: { token: getToken() },
  });
};

export const SendRoomMessage = async (roomId, payload) => {
  return axios.post(`${API_BASE_URL}/chat/rooms/${roomId}/messages`, payload, {
    headers: { token: getToken() },
  });
};

export const CreateRoomMessage = async (payload) => {
  return axios.post(`${API_BASE_URL}/chat/rooms`, payload, {
    headers: { token: getToken() },
  });
};

export const MessageslistAdmin = async (type, page, limit) => {
  return axios.get(`${API_BASE_URL}/chat/rooms`, {
    params: {
      ...(type ? { type } : {}),
      page,
      limit,
    },
    headers: { token: getToken() },
  });
};

export const uploadPrivate = async (FileId) => {
  return axios.get(`${API_BASE_URL}/upload/private-file/${FileId}`, {
    headers: {
      token: getToken(),
    },
    responseType: "blob",
  });
};